import UITileSection from 'UIComponents/tile/UITileSection';
import { H7 } from 'UIComponents/elements/headings';
import UITile from 'UIComponents/tile/UITile';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import EnrollmentListSizeExactAlert from 'automation-ui-canvas/containers/review/EnrollmentListSizeExactAlert';
import useHasListsToolAccess from 'automation-ui-enrollment/hooks/useHasListsToolAccess';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ILSListPreviewLink from 'automation-ui-enrollment/components/common/ILSListPreviewLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollExistingListView = ({
  objectTypeId,
  enrollmentList,
  flowName,
  enrollExistingState,
  setEnrollExistingState
}) => {
  const hasListsToolAccess = useHasListsToolAccess(objectTypeId);
  const previewLink = hasListsToolAccess ? /*#__PURE__*/_jsx(ILSListPreviewLink, {
    filterBranch: enrollmentList.filterBranch,
    workflowName: flowName,
    objectTypeId: objectTypeId,
    linkLabel: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.hybridCalculation.listsToolLink_cob",
      objectTypeId: objectTypeId
    })
  }) : undefined;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UITile, {
      compact: true,
      children: /*#__PURE__*/_jsxs(UITileSection, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsx(EnrollmentListSizeExactAlert, {
            objectTypeId: objectTypeId,
            listId: enrollmentList.listId,
            previewLink: previewLink
          })
        }), /*#__PURE__*/_jsx(H7, {
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.list.title_cob",
            objectTypeId: objectTypeId
          })
        }), /*#__PURE__*/_jsxs(UIToggleGroup, {
          name: "enroll-existing",
          children: [/*#__PURE__*/_jsx(UIRadioInput, {
            "data-test-id": "flow-enroll-existing-true",
            size: "small",
            className: "m-bottom-3",
            checked: !!enrollExistingState.shouldEnrollExistingFromListTriggers,
            onChange: () => setEnrollExistingState({
              shouldEnrollExistingFromListTriggers: true
            }),
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.list.yesOption_cob",
              objectTypeId: objectTypeId
            })
          }), /*#__PURE__*/_jsx(UIRadioInput, {
            "data-test-id": "flow-enroll-existing-false",
            checked: enrollExistingState.shouldEnrollExistingFromListTriggers !== null && enrollExistingState.shouldEnrollExistingFromListTriggers !== undefined && !enrollExistingState.shouldEnrollExistingFromListTriggers,
            size: "small",
            onChange: () => setEnrollExistingState({
              shouldEnrollExistingFromListTriggers: false
            }),
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.list.noOption_cob",
              objectTypeId: objectTypeId
            })
          })]
        })]
      })
    })
  });
};
export default EnrollExistingListView;